import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=82530714"
import script from "./Estadisticas.vue?vue&type=script&lang=js"
export * from "./Estadisticas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports